let routes = [

    // 焦炭
    {
        path: 'coke',
        name: '焦炭',
        component: () => import('@/views/coke/index'),
    },
    {
        path: 'coke/twoPage/enterprise',
        name: '焦炭重点企业资讯二级页',
        component: () => import('@/views/coke/twoPage/enterprise')
    },
    {
        path: 'coke/enterprise',
        name: '焦炭重点企业资讯详情页',
        component: () => import('@/views/coke/detail/enterprise')
    },
    {
        path: 'coke/twoPage/industry',
        name: '焦炭行业动态二级页',
        component: () => import('@/views/coke/twoPage/industry')
    },
    {
        path: 'coke/twoPage/standard',
        name: '焦炭技术及标准',
        component: () => import('@/views/coke/twoPage/standard')
    },
    {
        path: 'coke/industry',
        name: '焦炭行业动态详情页',
        component: () => import('@/views/coke/detail/industry')
    },
    {
        path: 'coke/twoPage/price',
        name: '焦炭价格指数二级页',
        component: () => import('@/views/coke/twoPage/price')
    },
    {
        path: 'coke/priceIndex',
        name: '焦炭价格指数详情页',
        component: () => import('@/views/coke/detail/priceIndex.vue')
    },
    {
        path: 'coke/twoPage/stock',
        name: '焦炭库存二级页',
        component: () => import('@/views/coke/twoPage/stock')
    },
    {
        path: 'coke/stock',
        name: '焦炭库存详情页',
        component: () => import('@/views/coke/detail/stock.vue')
    },
    {
        path: 'coke/twoPage/report',
        name: '焦炭研究报告二级页',
        component: () => import('@/views/coke/twoPage/report')
    },
    {
        path: 'coke/twoPage/rate',
        name: '焦炭开工率二级页',
        component: () => import('@/views/coke/twoPage/rate')
    },
    {
        path: 'coke/operatingRate',
        name: '焦炭开工率详情页',
        component: () => import('@/views/coke/detail/operatingRate.vue')
    },
    {
        path: 'coke/twoPage/cost',
        name: '焦炭开工率二级页1',
        component: () => import('@/views/coke/twoPage/cost')
    },
    {
        path: 'coke/cost',
        name: '焦炭开工率详情页2',
        component: () => import('@/views/coke/detail/cost.vue')
    },
    {
        path: 'coke/exit',
        name: '焦炭进出口量详情页',
        component: () => import('@/views/coke/detail/exit.vue')
    },
    {
        path: 'coke/twoPage/exit',
        name: '焦炭进出口量二级页',
        component: () => import('@/views/coke/twoPage/exit')
    },
    {
        path: 'coke/forecast',
        name: '焦炭价格预测详情页',
        component: () => import('@/views/coke/detail/forecast')
    },
    {
        path: 'coke/twoPage/forecast',
        name: '焦炭价格预测二级页',
        component: () => import('@/views/coke/twoPage/forecast')
    },
    {
        path: 'coke/enterpriseCapacity',
        name: '焦炭企业产能详情页',
        component: () => import('@/views/coke/detail/enterpriseCapacity.vue')
    },
    {
        path: 'coke/addCapacity',
        name: '焦炭新增淘汰产能详情页',
        component: () => import('@/views/coke/detail/addCapacity.vue')
    },
    {
        path: 'coke/cokeYield',
        name: '焦炭产量分省详情页',
        component: () => import('@/views/coke/detail/cokeYield')
    },
    {
        path: 'coke/twoPage/cokeYield',
        name: '焦炭产量分省二级页',
        component: () => import('@/views/coke/twoPage/cokeYield')
    },
    {
        path: 'coke/map',
        name: '焦炭地图',
        component: () => import('@/views/coal/detail/map.vue')
    },
    {
        path: 'coke/relatedProductsCoal',
        name: '焦炭外部链接详情表',
        component: () => import('@/views/coke/detail/relatedProductsCoal.vue')
    },
    {
        path: 'coke/reportSummary',
        name: '焦炭外部链接汇总表',
        component: () => import('@/views/coke/detail/reportSummary.vue')
    },
]

export default routes;
